import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/transactions-history-page.json'
import RichText from 'src/components/RichText'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

export default function DateFilterLimitInfo() {
  return (
    <RichText
      field={t('last_3_months_of_history')}
      components={{
        paragraph: ({ children }) => <div className={classes.info}>{children}</div>,
        strong: ({ children }) => (
          <a href={process.env.ZENDESK_SUPPORT_LINK} target='_blank' rel='noreferrer'>
            {children}
          </a>
        ),
      }}
    />
  )
}
